<template>
  <picture>
    <source
      v-for="(source, index) in sources"
      :key="index"
      type="image/webp"
      v-lazy-load :data-srcset="source.srcset"
      :media="source.media"
      :data-not-lazy="notLazy"
      :fetchpriority="fetchPriority"
      @error="onError"
    />

    <img
      ref="img"
      class="block object-cover"
      :width="width"
      :height="height"
      v-lazy-load :data-src="fallbackPicture"
      :alt="alt"
      @error="onError"
    />
  </picture>
</template>

<script>
import { ref } from "vue";
import defaultAvatar from "~/assets/default-avatar.png";

export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
    alt: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "100%",
    },
    notLazy: {
      type: Boolean,
      default: false,
    },
    fetchPriority: {
      type: String,
      default: "auto",
    },
  },
  setup(props) {
    const sourceWidths = [448, 336, 256, 192];
    const minWidths = [900, 400, 300, null];
    const sources = ref([]);
    const fallbackPicture = ref(defaultAvatar);

    if (props.person?.profilePhotoId) {
      sources.value = sourceWidths.map((size, index) => ({
        srcset: `${process.env.GOOGLE_STORAGE_URL}/${process.env.GOOGLE_STORAGE_PROFILE_CONVERTED_BUCKET}/${props.person.profilePhotoId}_${size}.webp`,
        media: minWidths[index] ? `(min-width: ${minWidths[index]}px)` : "",
      }));
      fallbackPicture.value = `${process.env.GOOGLE_STORAGE_URL}/${process.env.GOOGLE_STORAGE_PROFILE_CONVERTED_BUCKET}/${props.person.profilePhotoId}_256.jpg`;
    }

    const onError = (event) => {
      sources.value = [];
      fallbackPicture.value = defaultAvatar;
      console.error("Image load error:", event);
    };

    return {
      sources,
      fallbackPicture,
      onError,
    };
  },
};
</script>
